import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const GA_ID = process.env.REACT_APP_GA_ID;
const GSC = process.env.REACT_APP_GSC_VERIFICATION;

// Google Analytics 4 + Search Console. Dormant until env IDs are set.
export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!GA_ID || window.__gaLoaded) return;
    window.__gaLoaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
  }, []);

  // SPA page-view tracking on every route change
  useEffect(() => {
    if (GA_ID && window.gtag) {
      window.gtag("event", "page_view", { page_path: pathname + search });
    }
  }, [pathname, search]);

  if (!GSC) return null;
  return (
    <Helmet>
      <meta name="google-site-verification" content={GSC} />
    </Helmet>
  );
}
